const DATA_CLICK_NAME = 'data-mill-clickoutside';

const handleClick = (node: HTMLElement, onClick: () => void) => (event: MouseEvent) => {
	const clickOutsiders = document.querySelectorAll(`[${DATA_CLICK_NAME}]`);
	const lastOutsider = clickOutsiders?.[clickOutsiders.length - 1];

	if (lastOutsider !== node) {
		return;
	}

	if (!event.composedPath().includes(node)) {
		onClick();
	}
};

export default function clickOutside(
	node: HTMLElement,
	onClick?: () => void
): { update: () => void; destroy(): void } {
	let currentClickHandler = onClick ? handleClick(node, onClick) : undefined;

	if (currentClickHandler) {
		document.addEventListener('click', currentClickHandler);
	}
	node.setAttribute(DATA_CLICK_NAME, 'true');

	return {
		update(onClick?: () => void) {
			if (!onClick) {
				if (currentClickHandler) {
					document.removeEventListener('click', currentClickHandler);
				}
				return;
			}

			currentClickHandler = handleClick(node, onClick);
			document.addEventListener('click', currentClickHandler);
		},
		destroy() {
			if (currentClickHandler) {
				document.removeEventListener('click', currentClickHandler);
			}
		}
	};
}
